import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { config } from '../config';
import axios from 'axios';
import { validatePassword, validateConfirmPassword } from '../utils/validation';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [confirmTouched, setConfirmTouched] = useState(false);
  const [status, setStatus] = useState(null); // null | 'submitting' | 'done'
  const [error, setError] = useState('');

  if (!token) {
    return (
      <div className="center-container">
        <div className="card">
          <h1>Invalid link</h1>
          <p style={{ color: '#666', marginTop: '12px' }}>This reset link is invalid or has expired.</p>
          <p style={{ marginTop: '24px' }}>
            <Link to="/forgot-password">Request a new one</Link>
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPasswordTouched(true);
    setConfirmTouched(true);
    if (validatePassword(password) || validateConfirmPassword(password, confirmPassword)) return;

    setStatus('submitting');
    setError('');
    try {
      await axios.post(`${config.getBackendUrl()}/reset_password`, {
        token,
        new_password: password,
      });
      setStatus('done');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setStatus(null);
      const msg = err.response?.data?.detail || 'Something went wrong. Your link may have expired.';
      setError(msg);
    }
  };

  if (status === 'done') {
    return (
      <div className="center-container">
        <div className="card">
          <h1>Password updated</h1>
          <p style={{ color: '#666', marginTop: '12px' }}>
            Your password has been reset. Redirecting to login...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-container">
      <div className="card">
        <h1>Reset password</h1>
        <p style={{ color: '#666', marginBottom: '24px' }}>Enter your new password below.</p>
        <form onSubmit={handleSubmit}>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="password">New password</label>
            <input
              id="password"
              className={`input${passwordTouched && validatePassword(password) ? ' input-invalid' : passwordTouched && !validatePassword(password) ? ' input-valid' : ''}`}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={() => setPasswordTouched(true)}
            />
            {passwordTouched && validatePassword(password) && (
              <p className="field-error">{validatePassword(password)}</p>
            )}
          </div>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="confirmPassword">Confirm password</label>
            <input
              id="confirmPassword"
              className={`input${confirmTouched && validateConfirmPassword(password, confirmPassword) ? ' input-invalid' : confirmTouched && !validateConfirmPassword(password, confirmPassword) ? ' input-valid' : ''}`}
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onBlur={() => setConfirmTouched(true)}
            />
            {confirmTouched && validateConfirmPassword(password, confirmPassword) && (
              <p className="field-error">{validateConfirmPassword(password, confirmPassword)}</p>
            )}
          </div>
          {error && <p className="field-error">{error}</p>}
          <button type="submit" className="button" style={{ width: '100%' }} disabled={status === 'submitting'}>
            {status === 'submitting' ? 'Updating...' : 'Reset password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
